export default __webpack_public_path__ + "static/academicEnglishMoreCourseDetails-98e703e41403c9e5c160fff034968466.png";